import { Button, Paper } from '@mui/material'
import { COLUMNS_NAME } from 'Components/Constants/ColumnsNames'
import { currency } from 'Components/MUI_components/currencyFormatterTag'
import Reports from 'Components/Print/a4-report-print'
import React from 'react'
import { DownloadTableExcel } from 'react-export-table-to-excel'
import ReactToPrint from 'react-to-print'
import { pageStyle } from "Components/Print/printPagesStyles";
import { GENERAL_LEDGER_SOURCE_VALUE } from 'Components/Constants/GeneralLedgerSourcevalue'
import { GENERAL_LEDGER_SOURCE_NAME } from 'Components/Constants/GrnLedgerSourcename'

const PreviewTable = (props) => {
const  {
    tableRef,
    componentRef,
    value

} = props

const excludedSourceCodes = [
    GENERAL_LEDGER_SOURCE_VALUE.CHEQUE_PAYMENT_RETURNED,
    GENERAL_LEDGER_SOURCE_VALUE.CHEQUE_PAYMENT_REALIZED,
    GENERAL_LEDGER_SOURCE_VALUE.CHEQUES_MOVE_TO_BANK_PAYMENT,
    GENERAL_LEDGER_SOURCE_VALUE.CHEQUE_IN_HAND,
    GENERAL_LEDGER_SOURCE_VALUE.SUPPLIER_CHEQUE_PAYMENT_REALIZED,
    GENERAL_LEDGER_SOURCE_VALUE.SUPPLIER_CHEQUE_PAYMENT_RETURNED
  ];
  
  const DebitTotal = value
    .filter(row => 
      row.sourceCode !== excludedSourceCodes[0] &&
      row.sourceCode !== excludedSourceCodes[1] &&
      row.sourceCode !== excludedSourceCodes[2] &&
      row.sourceCode !== excludedSourceCodes[3] &&
      row.sourceCode !== excludedSourceCodes[4] &&
      row.sourceCode !== excludedSourceCodes[5]
    )
    .map(row => row.entryType == 0 ? parseFloat(row.amount) : 0)
    .reduce((sum, i) => sum + i, 0);

    const creditTotal = value   
    .filter(row => 
        row.sourceCode !== excludedSourceCodes[0] &&
        row.sourceCode !== excludedSourceCodes[1] &&
        row.sourceCode !== excludedSourceCodes[2] &&
        row.sourceCode !== excludedSourceCodes[3] &&
        row.sourceCode !== excludedSourceCodes[4] &&
        row.sourceCode !== excludedSourceCodes[5]

      ).map((row) => row.entryType == 1 ? parseFloat(row.amount) : 0)
    .reduce((sum, i) => sum + i, 0);

    return (
        <div >
            {value.length > 0 && (
                <Paper style={{ padding: "10px" }}>
                    <div className="flex-end">
                        <ReactToPrint
                            trigger={() => (
                                <Button
                                    style={{ margin: 5 }}

                                    variant="contained"
                                >
                                    Print
                                </Button>
                            )}
                            content={() => componentRef.current}
                            pageStyle={pageStyle.a4}
                        />
                        <DownloadTableExcel
                            filename="Day End"
                            currentTableRef={tableRef.current}
                        >
                            <Button
                                style={{ margin: 5 }}

                                variant="contained"
                            >
                                Export to Excel </Button>
                        </DownloadTableExcel>

                    </div>
                    <div className="justify-content-center"
                        ref={componentRef}>
                        <Reports
                            title={
                                "Preview Transactions"
                            }

                        >
                            <table
                                className="print-table mt "
                                aria-label="customized table"
                                ref={tableRef}>
                                <thead className="thead" style={{ borderBottom: "1px solid #24242450" }}>
                                    <tr style={{ backgroundColor: "#cacaca" }}>
                                        <th align="left">{COLUMNS_NAME.TRANSACTION_TYPE}</th>
                                        <th align="left">{COLUMNS_NAME.LEDGER_TYPE}</th>
                                        {/* <th align="left" >{COLUMNS_NAME.ENTRY_TYPE}</th> */}
                                        <th align="left">{COLUMNS_NAME.TRANSACTION_MODE}</th>
                                        <th align="right">{COLUMNS_NAME.DEBIT}</th>
                                        <th align="right">{COLUMNS_NAME.CREDIT}</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <>
                                        {value.map((row, index) => (
                                            <>
                                            {
                                            row.amount ==  "0.00" || row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.CHEQUE_PAYMENT_RETURNED   ||
                                            row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.CHEQUE_PAYMENT_REALIZED  || 
                                            row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.CHEQUES_MOVE_TO_BANK_PAYMENT  || 
                                            row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.CHEQUE_IN_HAND ||
                                            row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.SUPPLIER_CHEQUE_PAYMENT_REALIZED  || 
                                            row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.SUPPLIER_CHEQUE_PAYMENT_RETURNED  
                                            ? ("") : (
                                                <tr key={index}>
                                                <td align="left">
                                                    {
                                                      
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.BROUGHT_FORWARD_CASH_BOOK ? GENERAL_LEDGER_SOURCE_NAME.BROUGHT_FORWARD_CASH_BOOK : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.BROUGHT_FORWARD_BANK ? GENERAL_LEDGER_SOURCE_NAME.BROUGHT_FORWARD_BANK : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.BROUGHT_FORWARD_CREDIT_CARD ? GENERAL_LEDGER_SOURCE_NAME.BROUGHT_FORWARD_CREDIT_CARD : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.BROUGHT_FORWARD_AMANA_BANK ? GENERAL_LEDGER_SOURCE_NAME.BROUGHT_FORWARD_AMANA_BANK : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.BROUGHT_FORWARD_HNB_BANK ? GENERAL_LEDGER_SOURCE_NAME.BROUGHT_FORWARD_HNB_BANK : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.BROUGHT_FORWARD_SAMPATH_BANK ? GENERAL_LEDGER_SOURCE_NAME.BROUGHT_FORWARD_SAMPATH_BANK : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.BROUGHT_FORWARD_CREDIT_CARD_2 ? GENERAL_LEDGER_SOURCE_NAME.BROUGHT_FORWARD_CREDIT_CARD_2 : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.PAYMENT_RECEIPT ? GENERAL_LEDGER_SOURCE_NAME.PAYMENT_RECEIPT : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.CASH_PAYMENT ? GENERAL_LEDGER_SOURCE_NAME.CASH_PAYMENT : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.CHEQUE_PAYMENT ? GENERAL_LEDGER_SOURCE_NAME.CHEQUE_PAYMENT : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.CARD_PAYMENT ? GENERAL_LEDGER_SOURCE_NAME.CARD_PAYMENT : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.BANK_PAYMENT ? GENERAL_LEDGER_SOURCE_NAME.BANK_PAYMENT : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.RETURN_AMOUNT ? GENERAL_LEDGER_SOURCE_NAME.RETURN_AMOUNT : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.OVER_PAYMENT ? GENERAL_LEDGER_SOURCE_NAME.OVER_PAYMENT : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.EXPENSE_AMOUNT ? GENERAL_LEDGER_SOURCE_NAME.EXPENSE_AMOUNT : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.PAYMENT_VOUCHER ? GENERAL_LEDGER_SOURCE_NAME.PAYMENT_VOUCHER : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.SUPPLIER_CASH_PAYMENT ? GENERAL_LEDGER_SOURCE_NAME.SUPPLIER_CASH_PAYMENT : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.SUPPLIER_CHEQUE_PAYMENT ?  GENERAL_LEDGER_SOURCE_NAME.SUPPLIER_CHEQUE_PAYMENT: "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.SUPPLIER_CARD_PAYMENT ? GENERAL_LEDGER_SOURCE_NAME.SUPPLIER_CARD_PAYMENT : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.SUPPLIER_BANK_PAYMENT ? GENERAL_LEDGER_SOURCE_NAME.SUPPLIER_BANK_PAYMENT : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.PURCHASE_RETURN ? GENERAL_LEDGER_SOURCE_NAME.PURCHASE_RETURN : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.SALES_RETURN ? GENERAL_LEDGER_SOURCE_NAME.SALES_RETURN : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.CUSTOMER_CHEQUE_RETURN_CASH_PAYMENT ? GENERAL_LEDGER_SOURCE_NAME.CUSTOMER_CHEQUE_RETURN_CASH_PAYMENT: "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.CUSTOMER_CHEQUE_RETURN_CHEQUE_PAYMENT ? GENERAL_LEDGER_SOURCE_NAME.CUSTOMER_CHEQUE_RETURN_CHEQUE_PAYMENT : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.CUSTOMER_CHEQUE_RETURN_BANK_PAYMENT ? GENERAL_LEDGER_SOURCE_NAME.CUSTOMER_CHEQUE_RETURN_BANK_PAYMENT : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.CUSTOMER_CHEQUE_RETURN_CARD_PAYMENT ? GENERAL_LEDGER_SOURCE_NAME.CUSTOMER_CHEQUE_RETURN_CARD_PAYMENT : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.ONLINE_TRANSFER_PAYMENT ? GENERAL_LEDGER_SOURCE_NAME.ONLINE_TRANSFER_PAYMENT : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.SUPPLIER_ONLINE_TRANSFER_PAYMENT ? GENERAL_LEDGER_SOURCE_NAME.SUPPLIER_ONLINE_TRANSFER_PAYMENT : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.CUSTOMER_CHEQUE_RETURN_ONLINE_PAYMENT ? GENERAL_LEDGER_SOURCE_NAME.CUSTOMER_CHEQUE_RETURN_ONLINE_PAYMENT : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.EXPENSE_CASH_PAYMENT ? GENERAL_LEDGER_SOURCE_NAME.EXPENSE_CASH_PAYMENT : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.EXPENSE_CHEQUE_PAYMENT ? GENERAL_LEDGER_SOURCE_NAME.EXPENSE_CHEQUE_PAYMENT : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.EXPENSE_CARD_PAYMENT ? GENERAL_LEDGER_SOURCE_NAME.EXPENSE_CARD_PAYMENT : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.EXPENSE_BANK_PAYMENT ? GENERAL_LEDGER_SOURCE_NAME.EXPENSE_BANK_PAYMENT : "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.EXPENSE_ONLINE_PAYMENT ? GENERAL_LEDGER_SOURCE_NAME.EXPENSE_ONLINE_PAYMENT: "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.CHEQUES_MOVE_TO_BANK_PAYMENT ? GENERAL_LEDGER_SOURCE_NAME.CHEQUES_MOVE_TO_BANK_PAYMENT: "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.CHEQUE_PAYMENT_RETURNED ? GENERAL_LEDGER_SOURCE_NAME.CHEQUE_PAYMENT_RETURNED: "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.CHEQUE_PAYMENT_REALIZED ? GENERAL_LEDGER_SOURCE_NAME.CHEQUE_PAYMENT_REALIZED: "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.SUPPLIER_CHEQUE_PAYMENT_REALIZED ? GENERAL_LEDGER_SOURCE_NAME.SUPPLIER_CHEQUE_PAYMENT_REALIZED: "" ||
                                                        row.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.SUPPLIER_CHEQUE_PAYMENT_RETURNED ? GENERAL_LEDGER_SOURCE_NAME.SUPPLIER_CHEQUE_PAYMENT_RETURNED: "" ||
                                                        row.transactionTypeName ? row.transactionTypeName : ""}
                                                </td>
                                                <td align="left">
                                                    {row.ledgerType == 4601000001 ? "CASH BOOK" : "" ||
                                                     row.ledgerType == 4601000002 ? "BANK " : "" ||
                                                     row.ledgerType == 4601000003 ? "CREDIT CARD" : "" ||
                                                     row.ledgerType == 4601000007 ? "CREDIT CARD" : "" ||
                                                    //  row.ledgerType == 4601000004 ? "CAPITAL_ACCOUNT_PLR" : "" ||
                                                    //  row.ledgerType == 4601000005 ? "RICELAND_PVT_LTD" : "" || 
                                                    //  row.ledgerType == 4601000006 ? "CA_MR_RAFEEK" : ""
                                                    row.ledgerType == 4601000004 ? "AMANA BANK" : "" ||
                                                    row.ledgerType == 4601000005 ? "HNB" : "" || 
                                                    row.ledgerType == 4601000006 ? "SAMPATH BANK" : "" ||
                                                    row.ledgerType == 4601000006 ? "SAMPATH BANK" : "" 
                                                    }
                                                </td>
                                                <td align="left">{row.transactionType == 0 ? " CASH" : "CHEQUE"}</td>
                                                {row.amount < 0 ? (
                                                    <>
                                                        <td align="right"> {row.entryType == 0 ? `(${currency(row.amount)})`  : "-"}</td>
                                                        <td align="right">{row.entryType == 0 ? "-" : `(${currency(row.amount)})`  }</td>
                                                    </>
                                                   
                                                ):(
                                                    <>
                                                        <td align="right">{row.entryType == 0 ? currency(row.amount)  : "-"}</td>
                                                        <td align="right">{row.entryType == 0 ? "-" : currency(row.amount) }</td>
                                                    </>
                                              
                                                )}
                                                
                                            </tr>
                                            )}
                                                
                                            </>
                                        ))}
                                        <tr>
                                            <td colSpan={3}></td>
                                            <td align="right"><strong>{DebitTotal<0 ? `(${ currency(DebitTotal)})` : currency(DebitTotal)}</strong> </td>
                                            <td align="right"><strong>{creditTotal<0 ? `(${ currency(creditTotal)})` : currency(creditTotal) }</strong> </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={3}></td>
                                            <td  align="right" >
                                               <strong>Total</strong> 
                                            </td>
                                            <td  align="right" >
                                               <strong>{currency(DebitTotal - creditTotal)}</strong> 
                                            </td>
                                        </tr>

                                    </>
                                </tbody>
                            </table>
                            <div style={{textAlign:'center',marginTop:15}}> 
                                <strong>Bank Movement</strong> 
                            </div>
                            <table  className="print-table mt "
                                aria-label="customized table"
                                ref={tableRef}>
                                <thead className="thead" style={{ borderBottom: "1px solid #24242450" }}>
                                    <tr style={{ backgroundColor: "#cacaca" }}>
                                        <th align="left">{COLUMNS_NAME.TRANSACTION_TYPE}</th>
                                        <th align="left">{COLUMNS_NAME.LEDGER_TYPE}</th>
                                        <th align="right">{COLUMNS_NAME.DEBIT}</th>
                                        <th align="right">{COLUMNS_NAME.CREDIT}</th>
                                        <th align="right">{COLUMNS_NAME.NOT_APPLICABLE}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {value
                                .filter(row => 
                                  row.sourceCode == excludedSourceCodes[0] ||
                                  row.sourceCode == excludedSourceCodes[1] ||
                                  row.sourceCode == excludedSourceCodes[2]
                                ).map((elem)=>(
                                    <tr>
                                          <td align="left">
                                             {
                                                 elem.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.CHEQUES_MOVE_TO_BANK_PAYMENT ? GENERAL_LEDGER_SOURCE_NAME.CHEQUES_MOVE_TO_BANK_PAYMENT: "" ||
                                                 elem.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.CHEQUE_PAYMENT_RETURNED ? GENERAL_LEDGER_SOURCE_NAME.CHEQUE_PAYMENT_RETURNED: "" ||
                                                 elem.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.CHEQUE_PAYMENT_REALIZED ? GENERAL_LEDGER_SOURCE_NAME.CHEQUE_PAYMENT_REALIZED: ""  || 
                                                 elem.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.SUPPLIER_CHEQUE_PAYMENT_REALIZED ? GENERAL_LEDGER_SOURCE_NAME.SUPPLIER_CHEQUE_PAYMENT_REALIZED: "" ||
                                                 elem.sourceCode == GENERAL_LEDGER_SOURCE_VALUE.SUPPLIER_CHEQUE_PAYMENT_RETURNED ? GENERAL_LEDGER_SOURCE_NAME.SUPPLIER_CHEQUE_PAYMENT_RETURNED: "" 
                                             }
                                           </td>
                                           <td align="left">
                                           {elem.ledgerType == 4601000001 ? "CASH BOOK" : "" ||
                                                     elem.ledgerType == 4601000002 ? "BANK " : "" ||
                                                     elem.ledgerType == 4601000003 ? "CREDIT CARD" : "" ||
                                                   elem.ledgerType == 4601000004 ? "AMANA BANK" : "" ||
                                                    elem.ledgerType == 4601000005 ? "HNB" : "" || 
                                                    elem.ledgerType == 4601000006 ? "SAMPATH BANK" : "" ||
                                                    elem.ledgerType == 4601000006 ? "SAMPATH BANK" : "" 
                                                    }
                                           </td>
                                           <td align="right">{elem.entryType == 0 ? currency(elem.amount)  : "-"}</td>
                                            <td align="right">{elem.entryType == 1 ? currency(elem.amount)  : "-"  }</td>
                                            <td align="right">{elem.entryType == 2 ? currency(elem.amount)  : "-" }</td>
                                    </tr>
                                ))}

                                        {/* <tr>
                                            <td colSpan={2}></td>
                                            <td align="right"><strong>{currency(bankMovementDebitTotal)}</strong> </td>
                                            <td align="right"><strong>{currency(bankMovementCreditTotal)}</strong> </td>
                                            <td align='right'><strong>{currency(bankMovementTotal)}</strong></td>
                                        </tr>
                                <tr>
                                    <td>Total</td>
                                    <td></td>
                                </tr> */}

                                </tbody>

                            </table>
                           {value
                                .filter(row => 
                                  row.sourceCode == excludedSourceCodes[3]
                                ).map((elem)=>(
                                    <strong>{GENERAL_LEDGER_SOURCE_NAME.CHEQUE_IN_HAND} : {elem.amount} </strong> 
                                ))}
                 
                        </Reports>

                    </div>
                </Paper>
            )}

        </div>
    )
}

export default PreviewTable